module.exports = __webpack_public_path__ + "static/agent_orange-734353469d479b1f15a8ae7e456b6bfb.ttf";